// Users with admin access to the Bowler audit trail (full change history).
// Add lowercase email addresses here, one per entry.
// If the list is empty, no one can see the audit log.
// Set REACT_APP_BOWLER_ADMIN_USERS="a@x.com,b@x.com" at build time to override.
const _envList =
  process.env.REACT_APP_BOWLER_ADMIN_USERS
    ? process.env.REACT_APP_BOWLER_ADMIN_USERS.split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    : [];

const BOWLER_ADMIN_USERS: string[] = _envList.length > 0 ? _envList : [
  'mahesh.s.bhosale@maersk.com',
  'nilesh.chakkar@maersk.com',
];

export default BOWLER_ADMIN_USERS;
